import React from 'react';
import { TextField, Grid, Typography, Fab, Input } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { DatePicker } from '../../DatePicker';
import { inputFieldNames } from '../../../constants';
import FancyDropDown from '../../FancyDropDown';
import { Attachment as AttachmentIcon } from '@material-ui/icons';
import Attachments from '../../Attachments';

const useStyles = makeStyles((theme) => ({
  header: {
    paddingBottom: theme.spacing(1)
  },
  formContainer: {
    paddingBottom: theme.spacing(2)
  },
  dropDown: {
    marginTop: 8
  },
  cancelButton: {
    color: '#666666'
  },
  addAttachmentFab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  fab: {
    margin: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
    width: 210,
    height: '36px !important',
    borderWidth: 1.3,
    flex: 1
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  }
}));

const AddRecord = (props) => {
  const classes = useStyles();
  const {
    record,
    handleInputChange,
    personnels,
    fetchAllPersonnels,
    branchId,
    hideTitle,
    freezePersonnelList,
    showTrainingDropDown,
    courses,
    fetchAllCoursesForBranch,
    handleRemoveAttachment,
    allAttachments
  } = props;

  const hiddenFileInput = React.createRef();

  React.useEffect(() => {
    if (personnels.length === 0) {
      fetchAllPersonnels(branchId);
    }

    //Fetch all courses for the branch, if they are already not loaded.
    //Means showing inside the dialog, and no courses to show
    if (courses.length === 0) {
      if (branchId) {
        fetchAllCoursesForBranch(branchId);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (event) => {
    hiddenFileInput.current.children[0].click();
  };

  const onAttachmendAdded = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const newObj = {
      newlyAdded: true,
      removed: false,
      fileData: file,
      name: file.name
    };
    handleInputChange(newObj, inputFieldNames.COURSE_RECORD_ATTACHMENT);
    hiddenFileInput.current.children[0].value = null;
  };

  return (
    <React.Fragment>
      {!hideTitle ? (
        <Typography variant="h6" className={classes.header}>
          Add Record
        </Typography>
      ) : null}
      <Grid container spacing={3} className={classes.formContainer}>
        <Grid item xs={6}>
          <DatePicker
            id="eventRecordDate"
            htmlId="eventRecordDate"
            title="Date"
            handleDateChange={(date) =>
              handleInputChange(date, inputFieldNames.RECORD_DATE)
            }
            selectedDate={record.recordDate}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <div className={classes.dropDown}>
            <FancyDropDown
              htmlId="personnelId"
              label="Personnel"
              value={record.personnelId}
              handleChange={(e) =>
                handleInputChange(e, inputFieldNames.PERSONNEL_ID)
              }
              items={personnels}
              dropDownWidth="100%"
              valueField="id"
              displayField={['firstName', 'lastName']}
              required={true}
              disabled={freezePersonnelList}
            />
          </div>
        </Grid>
        {showTrainingDropDown ? (
          <Grid item xs={6}>
            <div className={classes.dropDown}>
              <FancyDropDown
                htmlId="coursesId"
                label="Training"
                // value={record.personnelId}
                handleChange={(e) =>
                  handleInputChange(e, inputFieldNames.COURSE)
                }
                items={courses}
                dropDownWidth="100%"
                valueField="id"
                displayField={'unitDescription'}
                required={true}
              />
            </div>
          </Grid>
        ) : null}
        <Grid item xs={6}></Grid>
        <Grid item xs={12}>
          <TextField
            id="recordNotes"
            label="Notes"
            multiline
            rows={2}
            fullWidth
            variant="outlined"
            onChange={(e) => handleInputChange(e, inputFieldNames.RECORD_NOTES)}
            value={record.notes}
          />
        </Grid>
      </Grid>

      {/***************** Attachment ******************/}
      <Grid item xs={12} className={classes.gridItem}>
        <Typography className={classes.label}>Attachments</Typography>
      </Grid>
      <Grid item xs={12} className={classes.gridItem}>
        <Fab
          id="addAttachmentBtn"
          color="primary"
          variant="extended"
          aria-label="add"
          onClick={handleClick}
          className={`${classes.addAttachmentFab} ${classes.button}`}
        >
          <AttachmentIcon className={classes.extendedIcon} />
          Add attachment
          <Input
            type="file"
            ref={hiddenFileInput}
            multiple={false}
            onChange={onAttachmendAdded}
            style={{ display: 'none' }}
          />
        </Fab>
      </Grid>
      {allAttachments && (
        <Grid item xs={12} className={classes.gridItem}>
          <Attachments
            allAttachments={allAttachments}
            onRemoveAttachment={handleRemoveAttachment}
          />
        </Grid>
      )}
    </React.Fragment>
  );
};

export default AddRecord;
